import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ButtonContainer, ResetButton, SignInButton } from './styled';

interface AccountExistsModalProps {
   show: boolean;
   onHide: () => void;
   onSignIn: () => void;
   onForgotPassword: () => void;
   email?: string;
   text?: string;
}

export const AccountExistsModal: React.FC<AccountExistsModalProps> = ({
   show,
   onHide,
   onSignIn,
   onForgotPassword,
   email,
   text,
}) => {
   return (
      <Modal show={show} onHide={onHide} centered>
         <Modal.Header closeButton>
            <Modal.Title>Account Found</Modal.Title>
         </Modal.Header>
         <Modal.Body>
            {email && <p>It looks like an account already exists for {email} but the incorrect password was provided.</p>}
            {text && <p>{text}</p>}
            {email && (<ButtonContainer>
               <ResetButton onClick={onForgotPassword}>
                  Reset Password
               </ResetButton>
               <SignInButton onClick={onSignIn}>
                  Sign In
               </SignInButton>
            </ButtonContainer>)}
            {text && <div style={{display: 'flex', justifyContent: 'flex-end'}}><Button variant='danger' onClick={onHide}>OK</Button></div>}
         </Modal.Body>
      </Modal>
   );
};